import _ from 'lodash'
import { CLEAR_ERROR } from '@/redux/actions/error.actions'
import { SET_ERROR, RETRY_ACTION } from '../actions/error.actions'

const initialState = {
	action: '',
	details: null,
	actionsToRetry: {
		showLayer: false,
		pendingActions: []
	}
}

const error = (state = initialState, action) => {
	const { error, showError } = action

	if (error && showError && _.isEmpty(state.details)) {
		return {
			...state,
			action: _.camelCase(action.type.replace(/(_FAILURE|_REQUEST|_SUCCESS)/, '')),
			details: error,
		}
	}

	switch (action.type) {
		case CLEAR_ERROR:
			window.parent?.postMessage({ event: 'reduxClearError', payload: action.payload }, '*')
			return {
				...state,
				action: '',
				details: null,
			}
		case SET_ERROR:
			return {
				...state,
				action: SET_ERROR,
				details: error,

			}
		case RETRY_ACTION.QUEUE_ACTION:
			return {
				...state,
				actionsToRetry: {
					showLayer: false,
					pendingActions: [
						...state.actionsToRetry?.pendingActions,
						action.payload
					]
				}
			}
		case RETRY_ACTION.SHOW_CTA:
			return {
				...state,
				actionsToRetry: {
					...state.actionsToRetry,
					showLayer: true,
				}
			}
		case RETRY_ACTION.RESET:
			return {
				...state,
				actionsToRetry: {
					showLayer: false,
					pendingActions: []
				}
			}
		default:
			return state
	}
}

export default {
	name: 'error',
	onlyReducer: error
}
